import { TFlightSearchFormData } from '@/feature/flight/search/types/search';
import { FlightSearchFormatter } from '@/feature/flight/search/lib/trip';

export const sseSearchParamsFormatter = (data: TFlightSearchFormData) => {
  const formatterResult = FlightSearchFormatter(data);

  const searchParams = new URLSearchParams({
    JourneyType: formatterResult.JourneyType,
    PassengerTypeQuantity: JSON.stringify(formatterResult.PassengerTypeQuantity),
    OriginDestinationInformation: JSON.stringify(formatterResult.OriginDestinationInformation),
  });

  return searchParams.toString();
};




